import { render, staticRenderFns } from "./set06.vue?vue&type=template&id=bc9065fe&scoped=true&"
import script from "./set06.vue?vue&type=script&lang=js&"
export * from "./set06.vue?vue&type=script&lang=js&"
import style0 from "./set06.vue?vue&type=style&index=0&id=bc9065fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9065fe",
  null
  
)

export default component.exports